import { createFileRoute } from '@tanstack/react-router'
import { UserDetailPage } from '../../../components/AdminUsers/UserDetail'

export const Route = createFileRoute('/admin/users/$id/{-$tab}')({
  component: AdminUserDetailRoute,
})

function AdminUserDetailRoute() {
  const { id, tab } = Route.useParams()
  return <UserDetailPage id={id} tab={tab} />
}
